import { memo } from 'react';
import { Box, useTheme } from '@mui/material';
import { FilledButton } from '@initia-digital/component-library';

import { MobileResponsiveSimpleStepper } from './Stepper';
import { CONFIG } from "../config/const";

const { PLAN_STEPS } = CONFIG;


const PlanNavigation = memo(({ 
    stage, 
    handleFormNav 
}: { 
    stage: string,
    handleFormNav: (type: 'NEXT' | 'BACK') => void 
}) => {
    const theme = useTheme();
    
    return (
        <>
            <Box px="20px">
                <MobileResponsiveSimpleStepper 
                    steps={PLAN_STEPS} 
                    activeStepValue={stage} 
                />
            </Box>
            <Box display="flex" px="20px" pt="10px" gap="2px">
                <Box>
                    <FilledButton
                        backgroundColor={theme.palette.secondary.main}
                        color={theme.palette.secondary.contrastText}
                        size="small"
                        onClick={() => handleFormNav('BACK')}
                    >
                        <Box px="20px"><b>Back</b></Box>
                    </FilledButton>
                </Box>
                <Box>
                    <FilledButton
                        backgroundColor={theme.palette.secondary.main}
                        color={theme.palette.secondary.contrastText}
                        size="small"
                        onClick={() => handleFormNav('NEXT')}
                    >
                        <Box px="20px"><b>Next</b></Box>
                    </FilledButton>
                </Box>
            </Box>
        </>
    );
});

export default PlanNavigation; 